import Api from '@/common/api.helper'

export default {
  state: {
    contactSend: [],
    activeCampaign: [],
    contactSectors: [],
    empreendimentos: []
  },
  actions: {
    sendContactForm ({ commit }, params) {
      return Api.post('/contact/send', params.data).then(response => {
        commit('setContactForm', response.data)
        return response
      })
    },
    sendActiveCampaign ({ commit }, params) {
      return Api.post('/contact/send-active-campaign', params.data).then(response => {
        commit('setActiveCampaign', response.data)
        return response
      })
    },
    listContactSectors ({ commit }) {
      return Api.get('/contacts/all').then(response => {
        commit('setContactSectors', response.data)
        return response
      })
    },
    loadEmpreendimentosContato ({ commit }) {
      return Api.get('/businesses/businesses/all').then(response => {
        commit('setEmpreendimentos', response.data)
        return response
      })
    }
  },
  mutations: {
    setContactForm (state, contactSend) {
      state.contactSend = contactSend
    },
    setActiveCampaign (state, activeCampaign) {
      state.activeCampaign = activeCampaign
    },
    setContactSectors (state, contactSectors) {
      state.contactSectors = contactSectors
    },
    setEmpreendimentos (state, empreendimentos) {
      state.empreendimentos = empreendimentos
    }
  },
  getters: {
    contactSend (state) {
      return state.contactSend
    },
    activeCampaign (state) {
      return state.activeCampaign
    },
    contactSectors (state) {
      return state.contactSectors
    },
    empreendimentosContato (state) {
      return state.empreendimentos
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/contact.js